import React from 'react';
import { Switch, Route, useRouteMatch, useParams } from 'react-router-dom';

import AddEditAclUser from './AddEditAclUser';
import ViewAclUser from './ViewAclUser';
import { useSelectedUser } from '../hooks';

function SelectedAclUser() {
  const match = useRouteMatch();
  const { id } = useParams();
  const [data] = useSelectedUser(id);

  return (
    <Switch>
      <Route
        exact
        path={`${match.path}/view`}
        render={() => <ViewAclUser data={data} />}
      />
      <Route
        path={`${match.path}/edit`}
        render={() => <AddEditAclUser data={data} />}
      />
    </Switch>
  );
}

export default SelectedAclUser;
